import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const usePreviewGoogleReviewAutoReply = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (preview: Api.IGoogleReviewAutoReplyPreview) => void;
}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: Api.IGoogleReviewAutoReplyPreviewRequest) => {
			return userSession.webServiceHelper.callAsync<Api.IGoogleReviewAutoReplyPreview>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'googleBusiness/reviewAutoReply/preview',
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
